import { createColDefs } from '@fortem-monorepo/react-ag'
import { defaultGetRowId } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { CustomAgGridProps } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'

export interface AllSWAPAGGTableProps extends CustomAgGridProps {}

export const AllSWAPAGGTable: React.FC<AllSWAPAGGTableProps> = ({ query, ...props }) => {
  const colDefs = createColDefs([
    { field: 'fortemidentifier' },
    { field: 'fxforwardfortemidentifier' },
    { field: 'prodccy' },
    { field: 'fundname' },
    { field: 'fundccy' },
    { field: 'banktraderef' },
    { field: 'counterpartycode' },
    { field: 'bondisin' },
    { field: 'underlyingbondisinref' },
    { field: 'assetswapfortemidentifier' },
    { field: 'basisswapfortemidentifier' },
    { field: 'ntbookingsecnum' },
    { field: 'paydelaybdays' },
  ])

  return (
    <Widget exposed className={'h-full'}>
      <WidgetHeaderWithQuery query={query} title="All SWAPAGG Entries" />
      <WidgetContent loading={query?.isLoading}>
        <CustomAgGrid columnDefs={colDefs} getRowId={defaultGetRowId} {...props} />
      </WidgetContent>
    </Widget>
  )
}
